import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

const LegalLinks = ({ className }: { className?: string }) => {
    const { t } = useTranslation()

    return (
        <p className={`flex flex-row flex-wrap items-center justify-center gap-x-2 max-w-none ${className ?? "text-sm text-gray-600"}`}>
            <Link className="underline" to="/faq">{t("titleFaq")}</Link>
            <span aria-hidden="true">·</span>
            <Link className="underline" to="/privacy">{t("titlePrivacy")}</Link>
            <span aria-hidden="true">·</span>
            <Link className="underline" to="/terms">{t("titleTerms")}</Link>
        </p>
    )
}

export default LegalLinks
